<template>
    <div class="echarts-bar-wrap-box">
        <div ref="echart" class="echarts-bar-wrap"></div>
    </div>
</template>

<script>
import echarts from 'echarts'
import {mixinCreateEchart} from '@/views/TheHome/mixins/createEchart'
import * as _ from 'lodash'

export default {
  name: 'moreLine',
  mixins: [mixinCreateEchart],
  props: {
    value: Object,
    title: String
  },
  data () {
    return {
      option: {
        color: ['#F57F31', '#F0BB58', '#58D9AC', '#43C4E2', '#66A2FC', '#3A90E8', '#576BF2', '#6E69FE', '#8366FC',
          '#AD71E9'],
        backgroundColor: '#fff',
        title: {
          show: false,
          text: this.title,
          padding: [2, 0, 0, 0],
          textStyle: {
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: -20,
          top: 40,
          right: 30,
          bottom: 10,
          containLabel: true
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        legend: {
          top: 20,
          data: []
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: (value, index) => {
              if (index % 2 === 0) {
                return value
              }
            }
          },
          axisTick: {
            show: false
          }
        },
        series: []
      },
      echart: null
    }
  },
  methods: {
    // 输入新值 渲染
    changeEchart () {
      // debugger
      if (this.value) {
        let option = this.value
        option.xAxis.boundaryGap = this.value.series[0].type === 'bar'
        if (this.value.series[0].type === 'bar') {
          option.series[0].barWidth = '50%'
          // option.series[0].itemStyle.barWidth = '15%'
        }
        this.changeStyle(option)
        this.echart.setOption(option)
        if (!this.value.series || !this.value.series[0].data || !this.value.series[0].data.length) {
          this.echart.showLoading('nodatas')
        }
      } else {
        this.echart.showLoading('nodatas')
      }
    },
    changeStyle (options) {
      let lineSeries = [
        {
          itemStyle: {
            color: '#208EFF'
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(32, 142, 255, 0.3)'
            }, {
              offset: 1,
              color: 'rgba(32, 142, 255, 0)'
            }])
          },
          smooth: true
        },
        {
          itemStyle: {
            color: '#6220FF'
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(98, 32, 255, 0.3)'
            }, {
              offset: 1,
              color: 'rgba(98, 32, 255, 0)'
            }])
          },
          smooth: true
        }
      ]
      if (options.series.length) {
        for (let index in options.series) {
          // debugger
          Object.assign(options.series[index], lineSeries[index])
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
    .echarts-bar-wrap-box {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .echarts-bar-wrap {
        /*padding: 18px 24px;*/
        background: #ffffff;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }
</style>
